import { createStyles } from "@mantine/core";
import React from "react";

const useStyles = createStyles((theme) => ({
  loader: {
    height: "30vh",
    width: "100%",
    paddingTop: 50,
  },
  text: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#000",
  },
}));
function RemainingCounts({ text, count }) {
  const { classes } = useStyles();
  return (
    <div className={classes?.text}>
      <div>
        {text} : {count}
      </div>
    </div>
  );
}

export default RemainingCounts;
